import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const postSaveNExitCrmEvent = (applicationUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.crmEvents.postSaveNExit, { applicationUid }),
    data,
  );

export const postCrmEvent = (applicationUid, data = null) =>
  postRequest(
    replaceInUrl(apiEndpoints.crmEvents.main, { applicationUid }),
    data,
  );
